const localePt = {
  // Empty view
  UDE_EMPTY_TITLE: 'Você ainda não se inscreveu em nenhuma especialização',
  UDE_EMPTY_DESC:
    'Já conhece nossas especializações? Alcance todo seu potencial com as diferentes rotas de aprendizado que oferecemos. Conheça mais aqui.',
  // Error view
  UDE_ENROLLED_TRACKS_ERROR: 'Ocorreu um erro ao obter suas especializações',
  TRACKS_ERROR: 'Ocorreu um erro ao obter as especializações',
  // Track card
  UDE_TRACK_COMPLETED: 'Especialização concluída',
};
export default localePt;
